module.exports = __webpack_public_path__ + "img/PL08128.d7fc1f55.png";